import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlobeLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_0_244)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8 0.583008C12.0959 0.583184 15.4158 3.90415 15.416 8C15.4158 12.0959 12.0959 15.4158 8 15.416C3.90415 15.4158 0.583184 12.0959 0.583008 8C0.583184 3.90415 3.90415 0.583184 8 0.583008ZM2.13184 8.75C2.42616 11.0749 4.06855 12.979 6.25195 13.6533C5.30516 12.1882 4.73982 10.5024 4.61328 8.75H2.13184ZM11.3857 8.75C11.2592 10.5028 10.6932 12.188 9.74609 13.6533C11.9303 12.9794 13.5728 11.0755 13.8672 8.75H11.3857ZM6.11621 8.75C6.26322 10.4912 6.9175 12.1515 7.99902 13.5225C9.08098 12.1513 9.73576 10.4916 9.88281 8.75H6.11621ZM6.25195 2.34473C4.06816 3.01896 2.42606 4.9247 2.13184 7.25H4.61328C4.73981 5.49695 5.3046 3.81024 6.25195 2.34473ZM7.99902 2.47656C6.91717 3.84775 6.26318 5.50847 6.11621 7.25H9.88281C9.73581 5.50823 9.08116 3.84785 7.99902 2.47656ZM9.74609 2.34473C10.6937 3.81036 11.2592 5.49674 11.3857 7.25H13.8672C13.5729 4.92426 11.9305 3.01857 9.74609 2.34473Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_0_244",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgGlobeLine;
